import { useEffect, useRef, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { Skeleton, Card, Select, Popover, Typography, Row } from 'antd'
import WeaverService from 'Services/WeaverService'
{ Paragraph } = Typography
import { GraphView } from 'Model'
import { branch } from 'Model/constants'


helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    Set a view to open by default when loading the space
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Open view by default'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

OpenDefaultViewPanel = ->

  [loading, setLoading] = useState(true)
  [views, setViews] = useState([])
  [selectedView, setSelectedView] = useState(undefined)

  useEffect(->
    (->
      setViews(
        graphViews = await GraphView.list(
          { authenticated: WeaverService.isAuthenticated() }
        )
      )
      setSelectedView((await GraphView.getOpenDefault())?.id())
      setLoading(false)
    )()
    undefined
  , [])

  useEffect(->
    if viewToSet = views.find((view) -> view.id() is selectedView)
      views = [
        _.map(views, (view) ->
          if view.get('openDefault')?
            view.unset('openDefault')

          view
        )...
        viewToSet.set('openDefault', true)
      ]
    else
      views = _.map(views, (view) ->
        if view.get('openDefault')?
          view.unset('openDefault')

        view
      )

    Weaver.Node.batchSave(views, { branch, commitMessage: "Update default view." })

    undefined
  , [selectedView])

  <Card
    title="Open view by default"
    extra={info}
    size="small"
    id="open-default-view-settings"
  >
    <Skeleton
      active
      paragraph={false}
      loading={loading}
    >
      <Select
        allowClear
        onSelect={setSelectedView}
        onClear={setSelectedView}
        value={selectedView}
        disabled={!WeaverService.userCanEdit()}
        placeholder="View to open by default"
        bordered={false}
        style={{ width: '100%' }}
      >
        {
          views.map((view) ->
            <Select.Option
              value={view.id()}
              key={view.id()}
            >
              { view.get('name') }
            </Select.Option>
          )
        }
      </Select>
    </Skeleton>
  </Card>

export default OpenDefaultViewPanel
